import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import type { FarmerProfile } from "@/mocks/farmerProfiles";

export default function FarmerDetailGallery({ farmer }: { farmer: FarmerProfile }) {
  return (
    <section className="sun-glaze bg-background-100 py-20 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-10 md:mb-12">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              In the Fields
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl leading-tight text-foreground-950 font-semibold">
            A Day With {farmer.name}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {farmer.gallery.map((image, index) => (
            <Reveal key={image.src} delay={index * 90}>
              <div className="rounded-lg overflow-hidden w-full h-64 md:h-80 border border-background-200">
                <img
                  src={image.src}
                  width={1200}
                  height={900}
                  alt={image.alt}
                  title={`${farmer.name} - ${image.alt}`}
                  className="w-full h-full object-cover object-top"
                  decoding="async"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}